// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers/reducers'; // Make sure to provide the correct path to your rootReducer

const store = configureStore({
  reducer: rootReducer,
});

export default store;
